import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import RefreshIcon from "@mui/icons-material/Refresh";
import type { SectionHeaderProps } from "@/types/dashboardtypes";
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  color = "#6e6fa9",
  onRefresh,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bgcolor: color,
      p: 1.5,
      color: "#fff",
      borderRadius: "8px 8px 0 0",
    }}
  >
    <Typography fontWeight={600}>{title}</Typography>
    {onRefresh && (
      <IconButton
        size="small"
        onClick={onRefresh}
        sx={{ color: "#fff" }}
        aria-label="Refresh"
      >
        <RefreshIcon fontSize="small" />
      </IconButton>
    )}
  </Box>
);